/**
 * 10_SECURITY_ARCHITECTURE §3 Session Layer.
 * 저장소 구현은 플랫폼별로 분리한다 (SA-02).
 * Native 는 Keychain / EncryptedSharedPreferences 를 쓴다. 평문 저장 금지 (SA-03).
 */
export interface TokenStore {
  readonly kind: string;
  get(): Promise<string | null>;
  set(token: string): Promise<void>;
  clear(): Promise<void>;
}

/** 테스트·SSR 용. 프로세스 메모리에만 둔다. */
export class MemoryTokenStore implements TokenStore {
  readonly kind = "memory";
  #token: string | null = null;
  async get() { return this.#token; }
  async set(t: string) { this.#token = t; }
  async clear() { this.#token = null; }
}
